
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dao/[symbol]/params",
      function () {
        return require("private-next-pages/dao/[symbol]/params/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dao/[symbol]/params"])
      });
    }
  